import Vue from 'vue';
import VueI18n from 'vue-i18n';
import strings_de from './strings_de';
import strings_de_kr from './strings_de-kr';
import strings_en from './strings_en';
import strings_pt from './strings_pt';
import strings_fr from './strings_fr';

Vue.use(VueI18n);

const messages = {
    en: strings_en,
    pt: strings_pt,
    de: strings_de,
    'de-kr': strings_de_kr,
    fr: strings_fr
};

const possibleLanguages = ['de', 'de-kr', 'en', 'pt', 'fr'];

function getLanguage() {
    let language =
        window.localStorage.getItem('userLanguage') ||
        (window.navigator.language ? window.navigator.language.substring(0, 2) : 'en');
    if (possibleLanguages.includes(language)) {
        return language;
    }

    return 'en';
}

const i18n = new VueI18n({
    locale: getLanguage(),
    fallbackLocale: 'en',
    messages
});

export default i18n;
